/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Vue from 'vue';
import Vuex from 'vuex';
import { createModule } from '@/plugins/vuex-toastr/module';
import toolbar from './modules/toolbar';
import sessionList from './modules/session-list';
import sessionView from './modules/session-view';
import user from './modules/user';
import socket from './modules/socket';

import adapters from './modules/adapters';

import debugToolbar from './modules/debug-toolbar';
import events from './modules/event';
import parameters from './modules/parameter';
import sessionParameters from './modules/session-parameter';
import sessionListener from './modules/session-listener';

import captcha from './modules/captcha';
import loader from './modules/loader';
import system from './modules/system';
import config from './modules/config';

import theme from './modules/theme';
import configs from '@/store/modules/configs';
import notifications from '@/store/modules/notifications';
import info from '@/store/modules/info';
import uiChannel from './modules/ui-channel';
import language from './modules/language';

import fileUploadingStatus from './modules/file-uploading-status';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    toolbar,
    sessionList,
    sessionView,
    user,
    socket,
    uiChannel,
    fileUploadingStatus,

    adapters,

    debugToolbar,
    events,
    parameters,
    sessionParameters,
    sessionListener,

    system,
    config,

    captcha,
    loader,

    theme,
    configs,
    notifications,
    info,
    language,
    toastr: createModule({
      dismissInterval: 8000,
    }),
  },
  strict: debug,
});
